import React from 'react';
import PropTypes from 'prop-types';

var sizeToScale = {
  small: 0.4,
  medium: 0.7,
  large: 1
};

var RibbonSpeciesIcon = function RibbonSpeciesIcon(_ref) {
  var species = _ref.species,
      theme = _ref.theme,
      size = _ref.size;

  var speciesClass = species.replace(' ', '-');
  var scale = sizeToScale[size];

  return React.createElement('span', {
    className: 'ontology-ribbon__species-icon--' + theme + ' ' + speciesClass,
    title: species
  });
};

RibbonSpeciesIcon.defaultProps = {
  theme: 'agr',
  size: 'small'
};

RibbonSpeciesIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  size: PropTypes.string,
  species: PropTypes.string.isRequired,
  theme: PropTypes.string
} : {};

export default RibbonSpeciesIcon;